import { IStoreEntityStateSlice, createEntitySlice } from '@aston/foundation';
import { IContactForm } from 'apps/console/src/app/shared-module/models';

export interface IContactFormState {
	form: IStoreEntityStateSlice<IContactForm>;
	isOpened: boolean;
}

export const initialState: IContactFormState = {
	form: createEntitySlice(),
	isOpened: false
};
